import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { FridgeTypes } from "@/components/FridgeTypes";
import { Defects } from "@/components/Defects";
import { About } from "@/components/About";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        window.__lenis = lenis;

        const onClick = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            const id = anchor.getAttribute("href");
            if (id && id.length > 1 && document.querySelector(id)) {
                e.preventDefault();
                lenis.scrollTo(id, { offset: -70, duration: 1.2 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            document.removeEventListener("click", onClick);
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="overflow-x-clip">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <FridgeTypes />
                <Defects />
                <About />
                <FinalCta />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}

export default App;
